(function() {
  'use strict';
  angular
    .module('ringbaPortal')
    .controller('CountryFlagController', CountryFlagController);

  function CountryFlagController() {
    const vm = this;

    vm.$onChanges = onChanges;

    function onChanges() {
      vm.actualCountryCode = vm.countryCode;

      if (vm.actualCountryCode) {
        vm.actualCountryCode = vm.actualCountryCode.split(':')[0];
      }
    }
  }
})();
